import { faArrowRight } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../assets/scss/components/_callout-banner.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router";

import { useAppContext } from "../contexts/AppContext";
import { useAppStore } from "../stores/AppStore";

export const CalloutBanner = () => {
	const appData = useAppContext();
	const { peakConfigs: storedPeakConfigs } = useAppStore(({ peakConfigs }) => ({ peakConfigs }));
	const peakConfigs = appData?.peakConfigs || storedPeakConfigs;

	let calloutBannerClass = "";
	let calloutBannerLink = "/next-day-flowers";
	let calloutBannerText = "Seasonal bouquets with FREE DELIVERY from £19.99.";

	if (peakConfigs?.VALENTINES_HEADER) {
		calloutBannerClass = "valentines-callout";
	}

	if (peakConfigs?.MOTHERS_DAY_HEADER) {
		calloutBannerClass = "mothers-day-callout";
		calloutBannerLink = "/mothers-day-flowers";
		calloutBannerText = "Mother's Day Flowers with FREE delivery from £19.99.";
	}

	if (peakConfigs?.CHRISTMAS_HEADER) {
		calloutBannerClass = "christmas-callout";
		calloutBannerLink = "/christmas-flowers";
		calloutBannerText = "Christmas Bouquets with FREE delivery from £19.99.";
	}

	const [visible, setVisible] = useState(true);

	useEffect(() => {
		if (typeof document === "undefined") return;
		const mainContent = document.querySelector(".main-content");
		if (!mainContent) return;

		const handleScroll = () => {
			if (mainContent.scrollTop > 350) {
				setVisible(false);
			}

			if (mainContent.scrollTop < 200) {
				//add a gap so it doesnt flicker
				setVisible(true);
			}
		};

		handleScroll();
		mainContent.addEventListener("scroll", handleScroll);
		return () => mainContent.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<section className={`callout-banner ${visible ? "" : "hidden"} ${calloutBannerClass}`}>
			<Link to={calloutBannerLink}>
				<span>{calloutBannerText}</span>

				<span>
					{" "}
					Explore the range now! <FontAwesomeIcon icon={faArrowRight} />{" "}
				</span>
			</Link>
		</section>
	);
};
